import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import arrowLeft from '../../../images/newDesign/arrow_black.svg';
import { CurrencyValue } from '../../../common/currencyValue';
import { StyledLastAction } from './LastAction.styled';

const LastAction = ({ payment }) => {
    const { t } = useTranslation();
    const ltr = useSelector(state => state.common.ltrEnabled);

    const isExpense = payment?.expense;

    const redirectToReport = () => {};

    return (
        <StyledLastAction expense={isExpense} ltr={ltr}>
            <div>
                <div className='action-type'>{isExpense ? t('expenses.expense') : t('expenses.income')}</div>
                <div className='action-info'>
                    <CurrencyValue currency={payment.currency}>{payment?.amount}</CurrencyValue> 
                    {isExpense ? ` ${t('buildings.to')} ${payment?.vendorName}` : ` ${t('buildings.from')} ${t('reports.apt')} ${payment?.apartmentNum}`}
                </div>
            </div>

            <div className='arrow' onClick={redirectToReport}><img src={arrowLeft} /></div>
        </StyledLastAction>
    )
}

export default LastAction;